
import styled from 'styled-components'
import { Skeleton } from '@arco-design/web-react'

const Lock = styled.div`
  .lock {
    position: fixed;
    width: 100vw;
    height: 100vh;
    z-index: 999;
  }

  .info {
    width: 100vw;
    height: 100vh;
    position: fixed;
    display: flex;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    pointer-events: none;
  }
`

export default function PageLock ({ enable, children, useSkeleton = false }) {
  return !enable ?
    (children ?? <></>)
    : <Lock>
      <div className="lock"/>
      {useSkeleton ? <div className="info">
        <Skeleton active/>
        <Skeleton active/>
        <Skeleton active/>
        <Skeleton active/>
        <Skeleton active/>
      </div> : <></>}
    </Lock>
}